/*=========================================================================================
  File Name: moduleKVDRGetters.js
  Description: KVDR module getters
  ----------------------------------------------------------------------------------------
  Item Name: KVDR - key value driving role
  Author: Ashwani Bhardwaj
  Author Email: bhardwaj.ashwani92@gmail.com
==========================================================================================*/


export default {}
